import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Zakon umetnost",
  "description": "",
  "published": "2007-02-26T00:00:00.000Z",
  "redirect_from": ["/blog/zakon-umetnost/swizec/280"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Danes sem bil z lepim PM-jem obvescen (ne bom rekel, da me je metron), da ima `}<a parentName="p" {...{
        "href": "http://www.marctauss.com/flash.html"
      }}>{`Marc Tauss`}</a>{` a.k.a `}<a parentName="p" {...{
        "href": "http://www.marctauss.com/flash.html"
      }}>{`metron`}</a>{` novo spletno stran s svojimi, ce lahko sam presodim, precudovitimi slikami. Vmes so njegove foto ilustracije, stil, ki ga ze od nekdaj obcudujem, in, kot kaze, se nekaj drugih stvari. Stvar si definitivno morate ogledati.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      